import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';
import { POPUP_WIDTH } from '../../const';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    badge: {
      width: POPUP_WIDTH,
      textTransform: 'uppercase',
      margin: theme.spacing(-2, -3.75, 0),
      padding: theme.spacing(1.5, 0),
      color: COLORS.success.active,
      backgroundColor: COLORS.success.badge,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      textAlign: 'center',
    },
    title: {
      marginTop: theme.spacing(4),
      color: COLORS.neutral.secondary,
      fontFamily: theme.typography.fontRobotoSlab,
      fontSize: theme.typography.pxToRem(24),
      lineHeight: theme.typography.pxToRem(36),
      textAlign: 'center',
    },
    description: {
      marginTop: theme.spacing(1),
      color: COLORS.neutral.blackBlue,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      textAlign: 'center',
    },
    button: {
      margin: theme.spacing(2, 'auto', 4),
    },
  }),
  {
    name: 'BookDemoPanel',
  }
);
